<template>
  <div class="doctorPage doctorSeach managerPlan">
    <div class="selectSearch">
      <el-form
        ref="formRef"
        :model="dataExportParams"
        class="qcFrom searchConditions"
        :inline="true"
      >
        <el-form-item label="选择时间" prop="dtMonth">
          <el-date-picker
            v-model="dataExportParams.dtMonth"
            type="month"
            placeholder="选择时间"
            value-format="yyyy-MM"
            :editable="false"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item label="选择机构" prop="hospIds">
          <el-select
            v-model="dataExportParams.hospIds"
            placeholder="请选择机构"
            @change="search"
            size="mini"
            class="multiple"
            multiple
            filterable
            collapse-tags
          >
            <el-option
              v-for="(item, index) in allHospitalsData.Hospitals"
              :key="index"
              :label="item.HospitalName"
              :value="item.HospitalGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
        <a href="javascript:;" class="addbtn" @click="exportExcel">导出</a>
      </el-form>
    </div>
    <div class="centerHome">
      <div class="ccHomel">
        <div class="compentTable">
          <el-table
            class="qcTable"
            ref="tableRef"
            :data="dataExportList"
            show-overflow-tooltip
            v-loading="loading"
            :row-key="tableRowKey"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="80"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column
              label="中心名称"
              prop="HospitalName"
              min-width="100"
            ></el-table-column>
            <el-table-column
              label="质控月份"
              prop="Month"
              min-width="90"
            ></el-table-column>
            <el-table-column
              label="抽样总数"
              prop="TotalNum"
              min-width="90"
            ></el-table-column>
            <el-table-column label="完成进度" prop="completedNum">
              <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-start">
                  <div class="progress">
                    <div
                      class="progress-bar progress-bar-success"
                      :style="`width: ${scope.row.Process}`"
                    ></div>
                    <span class="sr-only">{{ scope.row.Process }}</span>
                  </div>
                  <div slot="content" class="tableTooltip">
                    <div>
                      <em></em>
                      <span>已完成数量:{{ scope.row.CompletedNum }}</span>
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240">
              <template slot-scope="scope">
                <span class="tableOpe" @click="handleDetails(scope.row)"
                  >详情</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              class="pageAll"
              layout="prev, pager, next"
              :total="dataExportListTotal"
              :page-size="dataExportParams.pageSize"
              :current-page="dataExportParams.pageIndex"
              @current-change="currentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import axios from "@/js/api";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      tableRowKey: "HospitalGuid",
      exportList: [],
      loading: false,
      exportNameList: [],
    };
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["allHospitalsData"]),
    ...Vuex.mapState("dataExport", [
      "dataExportParams",
      "dataExportList",
      "dataExportListTotal",
      "dataExportDetailsParams",
    ]),
  },
  activated() {
    if (!this.dataExportParams.dtMonth) {
      const month = moment()
        .add(-1, "month")
        .format("YYYY-MM");
      this.dataExportParams.dtMonth = month;
    }
    this.dataExportParams.pageIndex = 1;
    this.getDataExportList();
    this.getAllHospitals({
      enable: -1,
      name: "",
      pageIndex: 1,
      pageCount: 999999,
    });
  },
  methods: {
    ...Vuex.mapActions("dataExport", ["dataExportListChange"]),
    ...Vuex.mapActions("breadcrumb", ["getAllHospitals"]),
    // 获取数据导出列表
    getDataExportList() {
      this.loading = true;
      const { hospIds, ...extra } = this.dataExportParams;
      axios
        .ajaxGet("get", Api.api.dataExport.getDataExportList, {
          ...extra,
          hospIds: hospIds.join(","),
        })
        .then((res) => {
          const { StatusCode, StatisticsDataList, TotalCount } = Object(
            res.data
          );
          if (StatusCode === 200) {
            this.dataExportListChange({
              list: StatisticsDataList || [],
              total: TotalCount || 0,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    search() {
      this.dataExportParams.pageIndex = 1;
      this.$refs.tableRef.clearSelection();
      this.exportList = [];
      this.getDataExportList();
    },
    // 表格分页参数改变
    currentChange(val) {
      this.dataExportParams.pageIndex = val;
      this.getDataExportList();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // 表格选择项变化
    handleSelectionChange(row) {
      this.exportList = row.map((item) => item.HospitalGuid);
      this.exportNameList = row.map((item) => item.HospitalName);
    },
    // 导出
    exportExcel() {
      if (this.exportList.length <= 0)
        return this.$message.error("请先选择导出数据");

      const date = new Date(this.dataExportParams.dtMonth);

      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      const formattedDate = `${year}年${month}月`;

      const action = axios.exportExcel(Api.api.dataExport.getDataExportDetails);
      const params = `?hospId=${this.exportList.join(",")}&dtMonth=${
        this.dataExportParams.dtMonth
      }&isExport=true&hospName=${this.exportNameList.join(
        ","
      )}${formattedDate}_抽样报告`;
      window.location.href = action + params;
    },
    // 查看详情
    handleDetails(row) {
      this.dataExportDetailsParams.hospId = row.HospitalGuid;
      this.dataExportDetailsParams.hospName = row.HospitalName;
      this.dataExportDetailsParams.dtMonth = this.dataExportParams.dtMonth;
      this.dataExportDetailsParams.pageIndex = 1;
      this.$router.push("/home/dataExport/details");
    },
  },
};
</script>

<style lang="scss" scoped>
.selectSearch {
  .el-form {
    ::v-deep .el-date-editor {
      .el-input__inner {
        height: 30px;
      }
      .el-input__prefix {
        left: 0;
        right: 0;
      }
    }
    .el-select.multiple {
      width: 300px;
      ::v-deep .el-input {
        .el-input__inner {
          height: 30px !important;
        }
      }
      ::v-deep .el-select__tags {
        margin-left: 10px;
        .el-tag--info {
          display: flex;
          margin: 0;
          .el-select__tags-text {
            display: block;
            max-width: 150px;
            line-height: 28px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      ::v-deep .el-tag__close.el-icon-close {
        top: 50%;
        transform: scale(0.7) translate(0, -50%);
      }
    }
  }
}
</style>
